/**
 * 功能: 单一element的录入, 可以是文本、数图专表, 图说可以生成新的数据, 可以关联除了图说外的附件数据
 */
<template lang="pug">
  div.show-element
    el-card(class="box-card" shadow="hover" style="margin:10px 0;display:flex")
      div(slot="header" class="clearfix" style="height:100%;display:flex;align-items:center;white-space:nowrap;")
        span(:style="{color:colors[index]}") {{'区域'+(index+1)+'：'}}
      div
        el-form(:inline="true" :model="element" :size="GLOBAL.SIZE_OF_INPUTBOX" )
          el-form-item(label="主题")
            el-input(v-model="element.title" placeholder="请输入主题" :size="GLOBAL.SIZE_OF_INPUTBOX" clearable style="width:160px")
          el-form-item(label="类型")
            el-select(v-model="element.attachment._class" placeholder="类型" :size="GLOBAL.SIZE_OF_INPUTBOX" clearable style="width:100px" @change="selectChange()")
              el-option(v-for ="item in _CLASS" :key="item.value" :label="item.label" :value="item.value")
          el-form-item(v-if="element.attachment._class == 0" label="厂牌")
            brandSelect(v-model="element.attachment.brand" :brandName="element.attachment.brandName" @brandName="getbrandName")
          el-form-item(v-if="element.attachment._class == 0" label="来源")
            el-input(type="text" v-model="element.attachment.source" :size="GLOBAL.SIZE_OF_INPUTBOX" style="width:150px")
          el-form-item(v-if="element.attachment._class == 0" label="描述")
            el-input(type="textarea" :rows="1" v-model="element.attachment.description" :size="GLOBAL.SIZE_OF_INPUTBOX" style="width:300px")
          el-form-item(v-if="element.attachment._class == 1||element.attachment._class == 2||element.attachment._class == 3" label="附件")
            el-button(type="primary" @click="connectAttachment(element.attachment._class)" :size="GLOBAL.SIZE_OF_INPUTBOX") 关联
            i(v-if="element.attachment.subObject" class="el-icon-success" style="color:#67C23A;margin:0 10px") 已关联id:{{element.attachment.subObject}}
            i(v-else class="el-icon-warning" style="color:#F56C6C;margin:0 10px") 未关联
          el-form-item(v-if="element.attachment._class == -1" label="内容")
            el-input(type="textarea" :rows="3" v-model="element.text" placeholder="请输入内容" :size="GLOBAL.SIZE_OF_INPUTBOX" clearable style="width:400px")
          el-form-item(v-if="element.attachment._class != -1" label="是否为核心数据")
            el-checkbox(:rows="1" v-model="element.attachment.core" :size="GLOBAL.SIZE_OF_INPUTBOX" clearable style="width:150px")
          el-form-item.fr
            el-button(type="primary" @click="handleShowOCR" v-if="ICanOcr && element.attachment._class == 0" :disabled="!canEditOcr" :size="GLOBAL.SIZE_OF_INPUTBOX" :loading="readLoading") 编辑OCR文本
            el-button(type="primary" @click="onImgLoaded()" v-if="ICanOcr" :size="GLOBAL.SIZE_OF_INPUTBOX" :loading="readLoading") 识别
            el-button(type="danger" @click="handleDelete(index)" :size="GLOBAL.SIZE_OF_INPUTBOX" icon="el-icon-delete")
            el-button.fr(:type="element.attachment.internalMemo | internalMemo" icon="el-icon-info" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="HandleShowMemo" v-if="isHaveMemo")
            el-button.fr( icon="el-icon-edit-outline" :size="GLOBAL.SIZE_OF_INPUTBOX" @click="updateAttachment" v-if="element.attachment._class > 0 && element.attachment.subObject")
    attachment-dialog(ref="dialog" @getInsertData="getInsertData" :brief="brief")
    memo-dialog(ref="memoDialog" :relativeId="relativeId" :title="memoTitle" @showMemo="showMemo")
    components(:is="currentView" :newTable="Info" :quoteInfo="Info" @saveQuote="saveQuote"  @addTable="addTable" :illInfo="Info" ref="view")
    el-dialog(:visible.sync="dialogTableVisible" width="90%")
      sizePro(:attachmentInfo="sizeInfo" @cancel="cancel")

</template>

<script>
import attachmentDialog from './attachmentDialog'
import Region from '../region'
import Enum from '@/apis/enum'
import memoDialog from '@/components/dialog'
import brandSelect from '@/components/brandSelect'
import api from '@/apis/attachment'
import TableDialog from '@/views/table/components/tableForm'
import quoteDialog from '@/views/quote/components/quoteDialog'
import sizePro from '@/views/size/components/index'

export default {
  components: { Region, attachmentDialog, memoDialog, brandSelect, TableDialog, sizePro, quoteDialog },
  props: {
    index: Number,
    element: {
      type: Object,
      default: () => { }
    },
    brief: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      title: '',
      colors: [],
      currentView: '',
      relativeId: '',
      memoTitle: '',
      newTable: { },
      dialogTableVisible: false,
      sizeInfo: { },
      Info: { },
      readLoading: false
    }
  },
  computed: {
    // 判断element是否包含memo
    isHaveMemo () {
      const { _class, subObject } = this.element.attachment
      if (_class === -1 && this.element._id) {
        return true
      } else if (_class !== -1 && subObject) {
        return true
      } else {
        return false
      }
    },
    // 检测是否可以执行ocr操作
    ICanOcr () {
      const { attachment } = this.element
      if (attachment._class === 1 && !attachment.subObject) {
        return true
      } else if (attachment._class === 0) {
        return true
      } else {
        return false
      }
    },
    // 检测是否可以编辑ocr里的数据
    canEditOcr () {
      const { attachment } = this.element
      const result = typeof attachment.OCRJson === 'string' ? JSON.parse(attachment.OCRJson) : attachment.OCRJson
      if (result && result.length > 0) {
        return true
      } else {
        return false
      }
    }
  },

  created () {
    this._CLASS = Enum._CLASS
    this.colors = Enum.COLORS
    this.element.brief = this.brief._id
  },

  methods: {
    // 识别元素数据
    onImgLoaded () {
      this.readLoading = true
      this.element.index = this.index
      this.$emit('getBase64', this.element)
    },
    // 获取厂牌数据
    getbrandName (brandName) {
      this.element.attachment.brandName = brandName
    },
    // 删除元素
    handleDelete (i) {
      this.$emit('deleteElement', i)
    },
    // 关联附件
    connectAttachment (_class) {
      this.$refs.dialog.show(_class)
    },
    // 获取关联附件的数据
    getInsertData (data, cb) {
      this.element.attachment.subObject = data._id
      cb && cb()
      this.$refs.dialog.close()
    },
    // 选择器变化触发事件
    selectChange () {
      this.$set(this.element.attachment, 'subObject', '')
      this.element.text = ''
      if (this.element.attachment._class === 0) {
        this.$set(this.element.attachment, 'brandName', this.brief.brandName)
        this.$set(this.element.attachment, 'brand', this.brief.brand)
      }
    },
    // 显示memo数据
    HandleShowMemo () {
      this.relativeId = this.element.attachment._class === -1 ? this.element._id : this.element.attachment.subObject
      this.memoTitle = this.element.title
      this.$refs.memoDialog.show()
    },
    showMemo (data) {
      this.element.attachment.internalMemo = data
    },
    // 显示修改ocr数据弹框
    handleShowOCR () {
      this.element.index = this.index
      this.$emit('updateOcrText', this.element)
    },
    // 显示更新附件的数据的弹框
    updateAttachment () {
      const _class = this.element.attachment._class
      if (_class === 1) { // 表说
        api.getTablebyId({ _id: this.element.attachment.subObject }).then(res => {
          if (res.data) {
            this.Info = res.data
            this.currentView = TableDialog
            this.$nextTick(() => {
              this.$refs.view.show()
            })
          }
        })
      } else if (_class === 2) { // 数说
        api.getSizePro({ id: this.element.attachment.subObject }).then(res => {
          if (res.data) {
            this.sizeInfo = res.data
            this.dialogTableVisible = true
          }
        })
      } else if (_class === 3) { // 专家说
        api.getQuotebyId({ _id: this.element.attachment.subObject }).then(res => {
          if (res.data) {
            this.currentView = quoteDialog
            this.Info = res.data
            this.$nextTick(() => {
              this.$refs.view.isShowQuoteDialog()
            })
          }
        })
      }
    },
    // 更新专家说数据
    saveQuote (quote, cb) {
      quote.brand = quote.brandName === '' ? null : quote.brand
      api.updateQuote(quote).then(r => {
        this.$message({ type: 'success', message: '已修改' })
      })
      cb && cb()
    },
    // 新建表说数据并且和当前element关联
    addTable (table, cb) {
      api.updateTable(table).then(res => {
        this.handleResult(res, '新建表说', () => {
          this.newTable = { }
          this.element.attachment.subObject = res.data._id
          cb && cb()
        })
      })
    },
    cancel () {
      this.dialogTableVisible = false
    },
    // 识别表格后显示弹框
    readTable (html) {
      this.readLoading = false
      this.currentView = TableDialog
      this.Info.html = html
      if (html.indexOf('<span>') >= 0) {
        this.$message.warning('表格识别失败，已转为文字')
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.view.show()
          })
        }, 500)
      } else {
        this.$nextTick(() => {
          this.$refs.view.show()
        })
      }
    }
  }
}

</script>

<style scoped>
.show-element {
  flex: 10;
  margin: 10px 10px;
}

</style>

<style>
.el-card__header{
border-right: 1px solid #EBEEF5;
}
</style>
